import createLucideIcon from '../createLucideIcon';

const MoveDiagonal2 = createLucideIcon('MoveDiagonal2Icon', [
  ['polyline', { points: '5 11 5 5 11 5', key: 'ncfzxk' }],
  ['polyline', { points: '19 13 19 19 13 19', key: '1mk7hk' }],
  ['line', { x1: '5', y1: '5', x2: '19', y2: '19', key: '4tvgsr' }],
]);

export default MoveDiagonal2;
